<div class="rokezzz-page-loader"></div>
<router-outlet></router-outlet>
<div class="rokezzz-notification"></div>
<div class="rokezzz-cookie-popup"></div>
